<template>
    <div class="innerBox">
      <div class="row">
        <div class="col-md-6">
          <h2 class="mb-4">Part Services</h2>
        </div>
        <div class="col-md-6 text-right align-middle">
          <div>
            <button class="btn btn-primary btn-sm" @click="modal.new = true">Tambah Group Baru</button>
          </div>
        </div>
      </div>
      
      <div class="row attachment-group" v-for="attachment in data">
        <!-- LEFT SIDE Start -->
        <div class="col-md-6" style="padding:0 25px">
          <div class="row">
            <div class="col outerBox">
              <div class="innerBox align-middle" style="background-color: #2D353C; color:white">
                <h2 class="attachment-name text-center m-0">{{ attachment.name.toUpperCase() }}</h2>
              </div>
            </div>
          </div>
          <div class="row sub-title" style="padding:8px; margin-top: 12px;">
            <div class="col flex-between">
              <h3>Part</h3>
              <button class="btn btn-sm btn-outline-success" @click="newSparepartLink(attachment.id, 'P')"><i class="fas fa-plus"></i></button>
            </div>
          </div>
          <div class="row item-row" v-for="part in attachment.sparepart_variants">
            <div class="col flex-between">
              <div class="align-middle">
                <span>{{ part.name }}</span>
              </div>
              <button class="btn btn-sm btn-outline-danger" @click="deletePartLink(attachment.id, part.sparepart_variant_id)"><i class="fas fa-times"></i></button>
            </div>
          </div>
        </div>
        <!-- LEFT SIDE End -->
        <!-- RIGHT SIDE Start -->
        <div class="col-md-6" style="padding:0 25px" :style="!mobile ? 'border-left:1px solid #e4e7ea' : ''">
          <div class="row sub-title" style="padding:8px">
            <div class="col flex-between">
              <h3>Jasa</h3>
              <button class="btn btn-sm btn-outline-success" @click="newSparepartLink(attachment.id, 'J')"><i class="fas fa-plus"></i></button>
            </div>
          </div>
          <div class="row item-row" v-for="jasa in attachment.sparepart_services">
            <div class="col flex-between">
              <div class="align-middle">
                <span>{{ jasa.name }}</span>
              </div>
              <button class="btn btn-sm btn-outline-danger" @click="deleteJasaLink(attachment.id, jasa.sparepart_id)"><i class="fas fa-times"></i></button>
            </div>
          </div>

          <!-- Button to delete group -->
          <div class="row item-row" v-if="attachment.sparepart_services.length == 0 && attachment.sparepart_variants.length == 0">
            <div class="col text-center align-middle" style="height: 70px;">
              <button class="btn btn-danger" @click="deleteGroup(attachment.id)">Hapus {{ attachment.name }}</button>
            </div>
          </div>

          <!-- Placeholder line if jasa is empty -->
          <div class="row item-row" v-else-if="attachment.sparepart_services.length == 0 && attachment.sparepart_variants.length > 0">
            <div class="col">
            </div>
          </div>

        </div>
        <!-- RIGHT SIDE Start -->
      </div>

      
  
      <new-group
        v-if="modal.new"
        @closeModal="modal.new = false"
        @updateTable="fetchData()"
      ></new-group>

      <new-link
        v-if="modal.link"
        :attachment_list="data.map((x)=>{return{id:x.id,name:x.name}})"
        :attachment_id="newLinkData.attachment_id"
        :sparepart_type="newLinkData.sparepart_type"
        @closeModal="modal.link = false"
        @updateTable="fetchData()"
      ></new-link>
  
    </div>
  </template>
  
  <script>
    import newGroup from './children/newGroup'
    import newLink from './children/newLink'
  
    export default {
      data () {
        return {
          mobile : this.isMobile(),
          modal : {
            new : false,
            link : false,
          },
          data : null,
          newLinkData : {
            attachment_id : null,
            sparepart_type : 'P'
          },
        }
      },
      components : {
        newGroup,
        newLink,
      },
      mounted () {
        this.fetchData()
      },
      methods : {
        newSparepartLink(attachment_id, sparepart_type){
          this.newLinkData.attachment_id = attachment_id;
          this.newLinkData.sparepart_type = sparepart_type;
          this.modal.link = true;
        },
        async fetchData () {
          await this.$http.get('/api/v1/sparepart-attachments')
          .then((resp)=>{
            this.data = resp.data.data;
          })
          .catch((err)=>{console.log(err)})
        },
        // processData(){
        //   let result = {}

        //   for (var i in this.data.attachments) {
        //     result[this.data.attachments[i].id] = {
        //       sparepart_attachment_id : this.data.attachments[i].id,
        //       sparepart_attachment_name : this.data.attachments[i].name,
        //       children : []
        //     }
        //   }

        //   for (var i in this.data.links) {
        //     result[this.data.links[i].sparepart_attachment_id].children.push({
        //       sparepart_id : this.data.links[i].sparepart_id,
        //       sparepart_name : this.data.links[i].sparepart_name,
        //       sparepart_type : this.data.links[i].sparepart_type
        //     })
        //   }

        //   this.data.table = Object.values(result);
        // },
        deleteJasaLink(attachment, sparepart){
          this.$swal.fire({
            title: 'Apakah anda yakin?',
            text: 'Anda akan menghapus jasa ini dari groupnya!',
            type: 'error',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Saya Yakin',
            cancelButtonText: 'Kembali'
          }).then((result)=>{
            if(result.value){
              this.$http.delete(`/api/v1/attachment-services/${attachment}/${sparepart}`)
              .then((resp)=>{
                this.$store.dispatch('triggerAlert', [true, ['Berhasil dihapus!']])
              })
              .catch((err)=>{console.log(err)})
              .finally(()=>{
                this.fetchData();
              })
            }
          })
        },
        deletePartLink(attachment, sparepart){
          let body = {
            sparepart_attachment_id : null,
            sparepart_variant_id : sparepart
          }
          this.$swal.fire({
            title: 'Apakah anda yakin?',
            text: 'Anda akan menghapus part ini dari groupnya!',
            type: 'error',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Saya Yakin',
            cancelButtonText: 'Kembali'
          }).then((result)=>{
            if(result.value){
              this.$http.patch('/api/v1/sparepart-attachments/add-sparepart-variant', body)
              .then((resp)=>{
                  this.$store.dispatch('triggerAlert', [true, ['Berhasil dihapus!']])
              })
              .catch((err)=>{
                console.log(err);
                this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
              })
              .finally(()=>{
                this.fetchData();
              })
            }
          })
        },
        deleteGroup(attachment){
          this.$swal.fire({
            title: 'Apakah anda yakin?',
            text: 'Anda akan menghapus group ini!',
            type: 'error',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Saya Yakin',
            cancelButtonText: 'Kembali'
          }).then((result)=>{
            if(result.value){
              this.$http.delete(`/api/v1/sparepart-attachments/${attachment}`)
              .then((resp)=>{
                this.$store.dispatch('triggerAlert', [true, ['Berhasil dihapus!']])
              })
              .catch((err)=>{console.log(err)})
              .finally(()=>{
                this.fetchData();
              })
            }
          })
        },
      }
    }
  </script>
  
  <style scoped>
    table th {
      font-size:16px;
    }

    .flex-between {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .attachment-group {
      padding:25px 0;
      border-top:1px solid #e4e7ea;      
    }

    .attachment-name {
      letter-spacing: 2px;
    }

    .sub-title {
      border-top:2px solid #e4e7ea;
      border-bottom:1px solid #e4e7ea;
    }

    .sub-title h3 {
      margin: 0;
    }

    .item-row {
      padding:8px;
      border-top: 1px solid #e4e7ea;
    }

    /* .item-row:not(:last-child) {
      border-bottom: 1px solid #e4e7ea;
    } */

    .item-row .item {
      
    }
  </style>